import ElementUI from 'element-ui'
// 失败弹窗


const error = function(cent, callback) {
    ElementUI.Message({
        message: cent,
        type: 'error',
        center: true,
        duration: 1500,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
};
// 成功弹窗
const success = function(cent, callback) {
    ElementUI.Message({
        message: cent,
        type: 'success',
        center: true,
        duration: 1500,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
};
// 取消
const infor = function(cent, callback) {
    ElementUI.Message({
        message: cent,
        type: 'info',
        center: true,
        duration: 1500,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
};
// 警告弹窗
const warning = function(cent, callback) {
    ElementUI.Message({
        message: cent,
        type: 'warning',
        center: true,
        duration: 1500,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
};
// 快速调回警告弹窗
const fastwarn = function(cent, callback) {
    ElementUI.Message({
        message: cent,
        type: 'warning',
        center: true,
        duration: 1000,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
};

// 文本成功提示消息
const sucTemplate = function( cent, callback) {
    ElementUI.Notification({
        type: 'success',
        message: cent,
        duration: 1500,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
}
// 文本告警提示消息
const warnTemplate = function(title, cent, callback) {
    ElementUI.Notification({
        type: "warning",
        title: title,
        message: cent,
        duration: 1500,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
}
// 文本告警提示消息
const errTemplate = function( cent, callback) {
    ElementUI.Notification({
        type: 'error',
        message: cent,
        duration: 1500,
        onClose: function() {
            if (callback != undefined && typeof callback === "function") {
                callback();
            }
        }
    });
}

// 删除弹窗提醒
const confirm = function(cent, suCallback) {
    ElementUI.MessageBox.confirm(cent, {
        title: '提示',
        message: cent,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => {
        if (suCallback != undefined && typeof suCallback === "function") {
            suCallback();
        }
    }).catch(() => {
        infor('已取消了操作');
    })
}


// 咨询弹窗提醒
const consumsg = function(cent, show, suCallback) {
    ElementUI.MessageBox.confirm(cent, {
        title: '购买咨询须知',
        message: cent,
        showConfirmButton: show,
        confirmButtonText: '点击购买',
        cancelButtonText: '取消',
    }).then(() => {
        if (suCallback != undefined && typeof suCallback === "function") {
            suCallback();
        }
    }).catch(() => {
        infor('已取消了操作');
    })
}


// 加载弹窗提醒
const loading = function(cent) {
    return ElementUI.Loading.service({
        lock: true,
        text: cent,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}

// 时间格式转换
const dateTime = function() {
    let date = new Date();
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

// 验证token是否存在
const lidatFun = function() {
    return trfaFun(localStorage.getItem('token'));
}

// 验证用户信息是否存在
const userFun = function() {
    return trfaFun(localStorage.getItem('userInfor'));
}

// 验证集合
const trfaFun = function(el) {
    if (el != '' && el != 'undefined' && el != null && el != undefined) {
        return true;
    } else {
        return false;
    }
}

// 生成随机字符串
const randFun = function() {　　
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';　　
    var maxPos = $chars.length;　　
    var pwd = '';　　
    for (var i = 0; i < 8; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));　　
    }　　
    return pwd;
}

export default {
    error,
    success,
    warning,
    sucTemplate,
    errTemplate,
    warnTemplate,
    infor,
    confirm,
    dateTime,
    loading,
    lidatFun,
    userFun,
    fastwarn,
    randFun,
    consumsg
}


// WEBPACK FOOTER //
// ./src/assets/public/utile.js